import { render } from "./FormBuilderFields.vue?vue&type=template&id=11406698&scoped=true&ts=true"
import script from "./FormBuilderFields.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormBuilderFields.vue?vue&type=script&setup=true&lang=ts"

import "./FormBuilderFields.vue?vue&type=style&index=0&id=11406698&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11406698"],['__file',"src/js/components/FormBuilderFields.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11406698"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11406698', __exports__)) {
    api.reload('11406698', __exports__)
  }
  
  module.hot.accept("./FormBuilderFields.vue?vue&type=template&id=11406698&scoped=true&ts=true", () => {
    api.rerender('11406698', render)
  })

}


export default __exports__